const button = "rounded-md p-2 text-muted-foreground hover:bg-accent hover:text-foreground transition-all duration-200 flex items-center gap-1.5";

const langLabel = "hidden sm:inline text-xs font-medium uppercase";

const iconH4_5W4_5 = "h-4.5 w-4.5";

export { button, langLabel, iconH4_5W4_5 };
